import {Module} from "vuex";
import {RootState} from "@/store/index";

export interface CmsModuleState {
  menuHide: boolean;
  menuHover: boolean;
  pageTitle: string;
  pageSubTitle: string;
}

const cmsModuleData = (): CmsModuleState => {
  return {
    menuHide: false,
    menuHover: false,
    pageTitle: " ",
    pageSubTitle: " ",
  };
};

export const CmsModule: Module<CmsModuleState, RootState> = {
  namespaced: true,
  state: cmsModuleData(),
  mutations: {
    setMenuHide(state, value?: boolean): void {
      state.menuHide = typeof value !== "undefined" ? value : !state.menuHide;
    },
    setMenuHover(state, value: boolean): void {
      state.menuHover = value;
    },
    setPageTitle(state, payload: {title: string; subTitle: string}): void {
      state.pageTitle = payload.title;
      state.pageSubTitle = payload.subTitle;
    },
  },
  getters: {
    getMenuHide(state): boolean {
      return state.menuHide;
    },
    getState(state): any {
      return state;
    },
  },
  actions: {},
};
